import Api from 'requestapijs';
import { HEADER, API_URL } from '../config';
import { QuestionMutationInput, QuestionMutationPayload, QuestionNode } from '../../schema';
import { Inject } from '../helpers';
import { UserService } from './userService';
import { mutation } from '../components/master/question/constant';

export class QuestionService {
  static instance: QuestionService;
  @Inject userService: UserService;

  constructor() {
    if (QuestionService.instance) {
      return QuestionService.instance;
    } else {
      QuestionService.instance = this;
    }
  }

  add(data: QuestionMutationInput, onSuccess: (reponse) => void, onError: (response) => void) {
    delete (data as any as QuestionNode).usedInQuestionnaire;
    Api.graphql<{ input: QuestionMutationInput }, QuestionMutationPayload>(
      API_URL,
      { input: { ...data, addedBy: this.userService.user$.value.id } },
      mutation,
      HEADER,
      (response) => {
        onSuccess(response);
      },
      (error) => {
        onError(error);
      },
    );
  }
}
